<div class="display-cultural-measurement-meta">
    <p>
        <adapt-entity-timestamp [timestamp]="culturalEntity.creationDate"
                                prefix="Entered on"
                                suffix="by"></adapt-entity-timestamp>
        <adapt-link-person [person]="culturalEntity.author"></adapt-link-person>
    </p>
    @if (showCulturalLeaderData) {
        <div>
            <div>
                @switch (culturalLeaderRelationships.length) {
                    @case (0) {
                        <p>
                            No
                            {{ configuration?.primaryName?.toLowerCase() }} was assigned at this time
                        </p>
                    }
                    @case (1) {
                        <p data-test="cultural-leader">
                            {{ configuration?.primaryName }}:
                            <adapt-link-person [person]="culturalLeaderRelationships[0].culturalLeader"></adapt-link-person>
                        </p>
                    }
                    @default {
                        <div>
                            <p>{{ configuration?.primaryCollectionName }}:</p>
                            <ul>
                                @for (relationship of culturalLeaderRelationships; track relationship) {
                                    <li>
                                        <adapt-link-person [person]="relationship.culturalLeader"></adapt-link-person>
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                }
            </div>
        </div>
    }
</div>
